import React, { useRef } from "react";

export interface OtpCodeInputProps {
  length?: number;
  value: string;
  onChange: (next: string) => void;
}

export const OtpCodeInput: React.FC<OtpCodeInputProps> = ({
  length = 6,
  value,
  onChange,
}) => {
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
  const digits = Array.from({ length }, (_, i) => value[i] ?? "");

  const handleChange = (index: number, raw: string) => {
    const digit = raw.replace(/\D/g, "").slice(-1);
    const chars = value.split("");
    chars[index] = digit;
    onChange(chars.join("").slice(0, length));
    if (digit && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (
    index: number,
    e: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (e.key === "Backspace" && !digits[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  return (
    <div className="flex w-full gap-2">
      {digits.map((digit, index) => (
        <input
          key={index}
          ref={(el) => {
            inputRefs.current[index] = el;
          }}
          aria-label={`Digit ${index + 1}`}
          value={digit}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          inputMode="numeric"
          maxLength={1}
          className="h-14 min-w-0 flex-1 rounded-xl border-2 border-ink-12 bg-card text-center text-xl font-bold text-ink-100 font-lexend focus:border-primary-100 focus:ring-1 focus:ring-primary-100 focus:outline-none"
        />
      ))}
    </div>
  );
};
